import type { ReactElement } from 'react'
import { CustomPageForm } from 'app/components/contacts/CustomPageForm'
import type { List } from 'app/generated/graphql'
import { showModal } from 'app/lib/modal'
import { notifySuccess } from 'app/services/notify.client'

/**
 * Opens a filter list's rule in the same dialog the custom page editor uses. A plain function
 * rather than a hook: the form reads the user and the columns it filters on itself, so there is
 * nothing here to hold.
 */
export function openListRuleEditor({
  list,
  onSaved,
  onDeleted,
  title = `Edit List`,
}: {
  list: List
  onSaved: () => void
  onDeleted: () => void
  title?: string | ReactElement
}): void {
  showModal(
    <CustomPageForm
      page="contacts"
      saveTo="list"
      list={list}
      onPageCreated={onSaved}
      onDelete={() => {
        notifySuccess(`${list.name} deleted`)
        onDeleted()
      }}
    />,
    { title, isFullScreen: false, overflowHidden: false, removePadding: true, useRadix: true },
  )
}
